import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  ul > :last-child {\n    li {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { BooksMobileFilterListWrapper } from "@/components/Books/List/BookListMobileFilterList";
import { MobileFilterListItem } from "@/components/Search/MobileFilterListItem";
import { SearchQueryKey } from "src/api/search";
import { stepCodeLookup } from "@/components/edition/category/components/content/ProductListItem";
import { styled } from "@mui/material";
export const MobileSearchFilterItemList = (param)=>{
    let { newFilterList , handleDetailFilter , selectedFilterList , mobileFilterSideSheet , handleMobileSideSheet  } = param;
    return /*#__PURE__*/ _jsx(BooksMobileFilterListWrapper, {
        children: /*#__PURE__*/ _jsx(WidthFullColumn, {
            children: /*#__PURE__*/ _jsx("ul", {
                children: Object.keys(newFilterList).map((filter, idx)=>{
                    const newFilters = newFilterList[filter].map((item)=>{
                        if (filter === SearchQueryKey.TICKETS) {
                            return item;
                        }
                        if (filter === SearchQueryKey.STEPS) {
                            const stepNum = typeof item === "number" ? item : Number(item);
                            return {
                                id: stepNum,
                                value: stepCodeLookup[stepNum] || String(item)
                            };
                        }
                        return {
                            id: item,
                            value: item
                        };
                    });
                    if (newFilterList[filter].length > 0) return /*#__PURE__*/ _jsx("li", {
                        children: /*#__PURE__*/ _jsx(MobileFilterListItem, {
                            title: filter,
                            filterItem: newFilters,
                            handleFilter: (filterType, id, value)=>{
                                handleDetailFilter(filterType, id);
                            },
                            selectedFilters: selectedFilterList,
                            openSlider: handleMobileSideSheet,
                            sliderOpen: mobileFilterSideSheet
                        })
                    }, idx);
                })
            })
        })
    });
};
const WidthFullColumn = styled("div")(_templateObject());
